import { environment } from '../../../../../environments/environment';

export const INTERNAL_MAC_DISTRIBUTORS_ENDPOINT = `${environment.apiBaseUrl}/internal/mac/distributors`;
export const INTERNAL_MAC_DISTRIBUTOR_ENDPOINT = (distributorId: number) =>
  `${environment.apiBaseUrl}/internal/mac/distributors/${distributorId}`;
export const INTERNAL_MAC_DISTRIBUTOR_CHILDREN_ENDPOINT = (merchantId: string) =>
  `${environment.apiBaseUrl}/internal/mac/distributors/children/${merchantId}`;
